var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1662_26410)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5807 12.4912C24.5807 11.5079 24.5009 10.7904 24.3282 10.0463H13.1003V14.4842H19.6908C19.558 15.5871 18.8405 17.2481 17.2459 18.3642L17.2236 18.5128L20.7737 21.263L21.0196 21.2875C23.2785 19.2013 24.5807 16.1319 24.5807 12.4912Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1003 24.1842C16.3291 24.1842 19.0397 23.1211 21.0196 21.2875L17.2459 18.3642C16.2361 19.0684 14.8807 19.56 13.1003 19.56C9.93785 19.56 7.25379 17.474 6.29699 14.5906L6.15675 14.6025L2.46533 17.4593L2.41705 17.5935C4.38359 21.5 8.42301 24.1842 13.1003 24.1842Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.29699 14.5905C6.04453 13.8464 5.89843 13.0491 5.89843 12.2253C5.89843 11.4015 6.04453 10.6042 6.28371 9.86014L6.27702 9.70167L2.53934 6.79895L2.41705 6.85712C1.60655 8.47822 1.14148 10.2986 1.14148 12.2253C1.14148 14.152 1.60655 15.9724 2.41705 17.5935L6.29699 14.5905Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1003 4.89063C15.3458 4.89063 16.8606 5.86062 17.7243 6.67121L21.0993 3.37588C19.0265 1.4492 16.3291 0.266602 13.1003 0.266602C8.42301 0.266602 4.38359 2.95066 2.41705 6.85717L6.28371 9.86019C7.25379 6.9768 9.93785 4.89063 13.1003 4.89063Z",
    fill: "#EB4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1662_26410"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.866669 0.266602)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.5e2ab0af0d11aed1b94b26453ebe544c.svg";
export { ForwardRef as ReactComponent };